<template>
  <Tabs class="mts-basic-tabs" v-bind="getBindValue">
    <Tabs.TabPane
      v-for="option in options"
      :key="option.value"
      :tab="option.label"
      :disabled="disabledAll || option.disabled"
      :forceRender="option.forceRender"
    >
      <template #tab>
        <slot :name="option.slotName"></slot>
      </template>
    </Tabs.TabPane>

    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </Tabs>
</template>

<script lang="ts" setup>
  import { Tabs, TabsProps } from 'ant-design-vue';
  import { ComponentOptionsMixin, computed, useAttrs } from 'vue';
  import { omit } from '@mts-fe/utils';

  defineOptions({
    name: 'MTabs',
    extends: Tabs as ComponentOptionsMixin,
    inheritAttrs: false,
  });

  interface TabOption {
    slotName?: string;
    disabled?: boolean;
    forceRender?: boolean;
    value: string | number;
    label?: string;
  }

  type MTabsProps = { options: TabOption[]; disabledAll?: boolean } & TabsProps;

  const props = withDefaults(defineProps<MTabsProps>(), { size: 'small', disabledAll: false });

  const attrs = useAttrs();
  const getBindValue = computed(() => {
    return { ...attrs, ...omit(props, ['options']) };
  });
</script>
